import React from 'react';
import { Dropdown } from '@ds/react-components';
import { Controller } from 'react-hook-form';
import frequencyTypes from 'constants/frequencyTypes';

const SuspensionPaymentFrequencyDdl = (props) => {
  const { classes, control, disabled = false } = props;
  const options = Object.values(frequencyTypes);

  return (
    <div className={classes.FormItem}>
      <Controller
        name="suspensionPaymentFrequency"
        control={control}
        render={({ onChange, value }) => {
          return (
            <Dropdown
              className={classes.Select}
              label={'Suspension Payment Frequency'}
              options={options}
              onChange={(e) => {
                onChange(e.value);
              }}
              value={options.filter((option) => option.value === value)}
              isSearchable={false}
              isDisabled={disabled}
            />
          );
        }}
      />
    </div>
  );
};

export default SuspensionPaymentFrequencyDdl;
